import axios from "axios";

export default class GetAddress {
	
	constructor() {

        this.cepField = document.querySelector('#cep')

        this.street = document.querySelector('#street')
        this.number = document.querySelector('#number')
        this.state = document.querySelector('#state')
        this.city = document.querySelector('#city')
        this.neighborhood = document.querySelector('#neighborhood')
		
		this.ready();
	}

	ready() {

        if(this.cepField) {

            this.cepField.addEventListener('blur', () => {
                this.clearFields()

                let cep = this.cepField.value.replace(/\D/g, '')

                if(cep != '') {
                    let validacep = /^[0-9]{8}$/;
                    //Valida o formato do CEP.
                    if(validacep.test(cep)) {

                        //Preenche os campos com "..." enquanto consulta webservice.
                        this.street.value="...";
                        this.neighborhood.value="...";
                        this.city.value="...";
                        // document.getElementById('uf').value="...";

                        axios.get('https://viacep.com.br/ws/'+cep+'/json/')
                            .then((response) => {
                                const data = response.data

                                this.street.value = data.logradouro
                                this.state.value = data.uf
                                this.city.value = data.localidade
                                this.neighborhood.value = data.bairro

                                this.number.focus()

                            })
                            .catch((error) => {
                                console.log(error);

                                this.clearFields()

                            });

                    }
                }

            })

        }

	}

    clearFields() {

        this.street.value = ''
        this.number.value = ''
        this.state.value = 0
        this.city.value = ''
        this.neighborhood.value = ''

    }

}

new GetAddress();